import React, { useEffect, useState } from "react";
import { Link, useNavigate  } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { useSelector } from "react-redux";

import NavLinks from "./nav";
import { useDictionary } from "../../contexts/dictionary";


import { VImage } from "../../style/base.style";
import { logo_svg } from "../../constants/images";
import GlobalLoader from "./Loader";
import { useContactType } from "../../contexts/ContactContext";
import { useFormHandling } from "../../hooks/formUtils";
import { RequestConfigs } from "../../api";
import { ProfileImg } from "../common/profileImage";
import { useDeviceType } from "../../contexts/DeviceContext";
import { MobileMenu } from "./mobileMenu";
import { set } from "date-fns";
import { useVendorType } from "../../contexts/VendorContext";

// import { setDataTheme } from "../../../core/data/redux/themeSettingSlice";


const Header = () => {
  const {translate} = useDictionary()
  const {contact} = useContactType()
  const {vendor} = useVendorType();
  const navigate = useNavigate();
  const {isMobile} = useDeviceType()
  const [mobileMenuOpen,setMobileMwnuOpen] = useState<boolean>(false)


 const [headerClass, setHeaderClass] = useState(
    "header header-custom header-fixed header-one home-head-one"
  );
  
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const scrollThreshold = 100;

      if (scrollPosition > scrollThreshold) {
        setHeaderClass("header header-custom header-fixed header-one home-head-one header-space pharmacy-header");
      } else {
        setHeaderClass("header header-custom header-fixed header-one home-head-one");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const {handleClick,serverRes} = useFormHandling({ requestType: RequestConfigs.logout })
  const handleLogout = () => {
    console.log("Logout clicked");
    handleClick()
  }

  const vendorLogoutForm = useFormHandling({ requestType: RequestConfigs.vendorLogout })
  const handleVendorLogout = () => {
    console.log("Vendor Logout clicked");
    vendorLogoutForm.handleClick()
  }



  useEffect(() => {
    if (serverRes) {
      if (serverRes.succeeded) {
        navigate("/login")
      }
    }
  }, [serverRes]);

  const onHandleMobileMenu = () => {
    setMobileMwnuOpen(true)
  };
  console.log("Header rendered",!contact,!vendor)
  return (
    <>
      <header className={headerClass}>
        <GlobalLoader/>
        <div id='popup-container'></div>
        <div className="container">
    

          <nav className="navbar navbar-expand-lg header-nav">
            <div className="navbar-header">
              <Link id="mobile_btn" to="#" onClick={() => onHandleMobileMenu()}>
                <span className="bar-icon">
                  <span />
                  <span />
                  <span />
                </span>
              </Link>
              <Link to="/" className="navbar-brand logo">
              <VImage src={logo_svg}  className="img-fluid" alt="Logo" />
              </Link>
            </div>
            
              {

                !isMobile &&
                <ul className="main-nav">
                <NavLinks />
                </ul>
              }
              {
                isMobile &&
                <MobileMenu isOpen={mobileMenuOpen} onClose={()=>setMobileMwnuOpen(false)}/>
              }  
             
                
                
           
            <ul className="nav header-navbar-rht">
              {
                !contact && !vendor &&
                <>
                <li className="register-btn">
                <Link to="/login" className="btn btn-primary log-btn">
                  <i className="feather icon-lock" />
                  {translate('login')}
                </Link>
              </li>
              <li className="register-btn">
                <Link to="/register" className="btn btn-second reg-btn">
                  <i className="feather icon-user" />
                  {translate('register')}
                </Link>
              </li>

               <li className="register-btn">
                <Link to="/partner-login" className="btn btn-partner reg-btn">
                  
                  {translate('partners')}
                </Link>
              </li>
                </>
                

              }
              {
                contact &&
                <>
                   {/* User Menu */}
                   <li className="nav-item dropdown has-arrow logged-item">
                    <a
                      href="#"
                      className="nav-link ps-0"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span className="user-img">
                       <ProfileImg width={40} height={40}/>
                      </span>
                    </a>
                    <div className="dropdown-menu dropdown-menu-end">
                      <div className="user-header">
                        <div className="avatar avatar-sm">
                        <ProfileImg width={20} height={20}/>
                        </div>
                        <div className="user-text">
                          <h6>{contact.Full_Name}</h6>
                          <p className="text-muted mb-0">{translate('insured')}</p>
                        </div>
                      </div>
                      <Link className="dropdown-item" to="/dashboard">
                        {translate('dashboard')}
                      </Link>
                      <Link className="dropdown-item" to="/dashboard/profile">
                      {translate('settings')}
                      </Link>
                      <a className="dropdown-item" href="/login">
                      <Link to="#" onClick={handleLogout}>
                        {translate('logout')}
                      </Link>
                      
                      </a>
                    </div>
                  </li>
                  {/* /User Menu */}
                </>
              }

              {
                vendor &&
                <>
                   {/* User Menu */}
                   <li className="nav-item dropdown has-arrow logged-item">
                    <a
                      href="#"
                      className="nav-link ps-0"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span className="user-img">
                       <ProfileImg width={40} height={40}/>
                      </span>
                    </a>
                    <div className="dropdown-menu dropdown-menu-end">
                      <div className="user-header">
                        <div className="avatar avatar-sm">
                        <ProfileImg width={20} height={20}/>
                        </div>
                        <div className="user-text">
                          <h6>{vendor.Vendor_Name}</h6>
                          <p className="text-muted mb-0">{translate('insured')}</p>
                        </div>
                      </div>
                      <a className="dropdown-item" href="/partner-login">
                      <Link to="#" onClick={handleVendorLogout}>
                        {translate('logout')}
                      </Link>
                      
                      </a>
                    </div>
                  </li>
                  {/* /User Menu */}
                </>
              }
              
              
            </ul>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
